<template>
  <div class="modal-window-component">
    <div>
      <div>
        <slot name="content"></slot>
      </div>
      <div>
        <div>
          <button v-if="cancelable" v-on:click="cancelClicked">CANCEL</button>
          <button v-on:click="okClicked">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {EventBus} from '../utils/EventBus.js'
export default {
  props: ['sig', 'cancelable'],
  methods: {
    cancelClicked: function () {
      var self = this
      EventBus.$emit('modal-window-cancel', {sig: self.sig})
    },
    okClicked: function () {
      var self = this
      EventBus.$emit('modal-window-ok', {sig: self.sig})
    }
  }
}
</script>
<style lang="scss" scoped>
div.modal-window-component{
  position: fixed;
  background-color: rgba(0,0,0,.8);
  z-index: 9999;
  top:0;
  left:0;
  right:0;
  bottom:0;
  > div{
    width:300px;
    margin:0 auto;
    top:200px;
    background-color: #ffffff;
    padding: 4px 0;
    > div{
      padding:8px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/editors/ModalWindow.vue